import { render, staticRenderFns } from "./TqOnTopContainer.vue?vue&type=template&id=2da2aa92&scoped=true&"
import script from "./TqOnTopContainer.vue?vue&type=script&lang=js&"
export * from "./TqOnTopContainer.vue?vue&type=script&lang=js&"
import style0 from "./TqOnTopContainer.vue?vue&type=style&index=0&id=2da2aa92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da2aa92",
  null
  
)

export default component.exports